import { EmptyFileSystem } from 'langium';
import { parseHelper } from 'langium/test';
import { createPypestreamPifServices } from '../pypestream-pif-module.js';
/**
 * Validates JSON input and returns only the diagnostics (errors, warnings, info).
 * This is similar to compileJson but only returns validation results without the parsed AST.
 *
 * @param input - The JSON string to validate
 * @returns A promise that resolves to an array of ExtendedDiagnostic objects
 *
 * @example
 * ```typescript
 * const diagnostics = await validateJson(
 *   '[
 *     { "nodeNumber": 1, "nodeType": "D", "nodeName": "A Node", ... },
 *     { "nodeNumber": 2, "nodeType": "D", "nodeName": "A Node", ... },
 *   ]'
 * );
 * ```
 */
export const validateJson = async (input) => {
    // Create a fresh services instance for each call to prevent memory accumulation
    // When the function returns, the services instance (and all its documents) can be garbage collected
    const services = createPypestreamPifServices(EmptyFileSystem);
    // Use parseHelper which handles document creation and parsing correctly
    const parse = parseHelper(services.PypestreamPif);
    const langiumDocument = await parse(input, { validation: true });
    return (langiumDocument.diagnostics ?? []);
};
//# sourceMappingURL=validate-json.js.map